import { createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom';

import { AppProviders } from './provider/AppProviders';
import { appRoutes } from './route/AppRoutes';
import './stylesheet/app.scss';

export const App = () => {
  const router = createBrowserRouter(createRoutesFromElements(appRoutes()));

  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
};
